import React from 'react';
import { Layout } from 'src/Layout';
import { person } from 'src/config';
import { HomeHero, MyClients, WhatIDo, WhoIAm } from 'src/section';

const UnmemoHome: React.FC = () => (
  <Layout
    title={`${person.name} - ${person.designation}`}
    description="I&#039;m Isha Hasan, Front-end Developer based in Karachi, Pakistan. I created many projects over the years. I focus on code quality and best practices."
    keywords="front-end developer, react developer, web developer, freelance developer"
  >
    <HomeHero />
    <WhoIAm />
    <WhatIDo />
    <MyClients />
  </Layout>
);

export const Home = React.memo(UnmemoHome);
